// import React, { useState } from 'react';

// import hotelLogo from '../assets/img/elite-logo.png';
// import AdminHeader from '../components/AdminHeader';
// import Dashboard from '../pages/AdminDashboard';
// import Bookings from '../pages/AdminBookings';
// import Rates from '../pages/AdminRates';
// import Inventory from '../pages/AdminInventory';


// const Home = () => {
//   const [activeTab, setActiveTab] = useState("dashboard");

//   return (
//     <div className="flex h-screen overflow-hidden">
//       {/* Sidebar */}
//       <nav className="w-64 min-w-[16rem] bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 text-white p-6 shadow-lg h-full">
//         {/* Logo */}
//         <div className="mb-8 flex flex-col items-center justify-center">
//           <img 
//             src={hotelLogo} 
//             alt="Hotel Logo" 
//             className="w-32 h-32 object-cover rounded-full shadow-xl border-4 border-gray-700 transform transition-transform duration-500 hover:scale-110 hover:rotate-3"
//           />
//           <div className="mt-4 text-lg font-bold text-gray-100 tracking-widest uppercase transition-opacity duration-700 opacity-80 hover:opacity-100 text-center">
//             Hiwa Boutique Hotel
//           </div>
//         </div>

//         {/* Navigation Links */}
//         <ul className="space-y-4 text-lg">
//           <li>
//             <button onClick={() => setActiveTab("dashboard")} className="w-full text-left py-2 px-4 rounded-lg hover:bg-gray-700 transition">
//               Dashboard
//             </button>
//           </li>
//           <li>
//             <button onClick={() => setActiveTab("bookings")} className="w-full text-left py-2 px-4 rounded-lg hover:bg-gray-700 transition">
//               Bookings
//             </button>
//           </li>
//           <li>
//             <button onClick={() => setActiveTab("rates")} className="w-full text-left py-2 px-4 rounded-lg hover:bg-gray-700 transition">
//               Rates  
//             </button>
//           </li>
//           <li>
//             <button onClick={() => setActiveTab("inventory")} className="w-full text-left py-2 px-4 rounded-lg hover:bg-gray-700 transition">
//             Inventory
//             </button>
//           </li>
          
//         </ul>
//       </nav>

//       {/* Main Content */}
//       <div className="flex-1 p-4 md:p-8 bg-gray-100 overflow-auto">
//         <div className="flex items-center justify-between mb-8">
//           <AdminHeader />
//         </div>

//         {/* Performance Overview and Active Tab */}
//         <div className="h-full">
//           {activeTab === "dashboard" && <Dashboard />}
//           {activeTab === "bookings" && <Bookings />}
//           {activeTab === "rates" && <Rates />}
//           {activeTab === "inventory" && <Inventory />}
         
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Home;


import React, { useState, useRef, useEffect } from 'react';

import hotelLogo from '../assets/img/elite-logo.png';
import appConfig from '../config/appConfig';
import AdminHeader from '../components/AdminHeader';
import Dashboard from '../pages/AdminDashboard';
import Bookings from '../pages/AdminBookings';
import Rates from '../pages/AdminRates';
import Inventory from '../pages/AdminInventory';
import WalkIn from '../pages/AdminWalkIn';
import { FaBook, FaChartPie, FaDoorOpen, FaTags, FaThLarge } from 'react-icons/fa';

const Home = () => {
  const [activeTab, setActiveTab] = useState("dashboard");
  const [sidebarWidth, setSidebarWidth] = useState(256); // Initial width
  const sidebarRef = useRef(null);
  const isResizing = useRef(false);
  const currentX = useRef(0);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (isResizing.current) {
        const deltaX = e.clientX - currentX.current;
        setSidebarWidth(prevWidth => Math.max(200, Math.min(400, prevWidth + deltaX))); // Limit width
        currentX.current = e.clientX;
      }
    };

    const handleMouseUp = () => {
      isResizing.current = false;
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);

  const handleMouseDown = (e) => {
    if (e.target === sidebarRef.current || sidebarRef.current.contains(e.target) ) { //only resize when clicking on sidebar
      isResizing.current = true;
      currentX.current = e.clientX;
    }
  };


  return (
    <div className="flex flex-col md:flex-row h-screen overflow-hidden">
      {/* Sidebar */}
      <nav
        className="bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 text-white p-4 md:p-6 shadow-lg h-full md:h-screen transition-width duration-300"
        style={{ width: sidebarWidth, resize: 'horizontal', overflow: 'auto' }} // Added inline style
        ref={sidebarRef}
        onMouseDown={handleMouseDown} // Added mouse event listener
      >
        {/* Logo */}
        <div className="mb-4 md:mb-8 flex flex-col items-center justify-center">
          <img
            src={hotelLogo}
            alt="Hotel Logo"
            className="w-24 h-24 md:w-32 md:h-32 object-cover rounded-full shadow-xl border-4 border-gray-700 transform transition-transform duration-500 hover:scale-110 hover:rotate-3"
          />
          <div className="mt-2 md:mt-4 text-lg font-bold text-gray-100 tracking-widest uppercase transition-opacity duration-700 opacity-80 hover:opacity-100 text-center">
            {appConfig.hotel.name}
          </div>
        </div>

        {/* Navigation Links */}
        <ul className="space-y-2 md:space-y-3 text-base md:text-lg">
          {[
            { id: 'dashboard', label: 'Dashboard', icon: FaChartPie },
            { id: 'walkin', label: 'Walk-in Booking', icon: FaDoorOpen },
            { id: 'bookings', label: 'Bookings', icon: FaBook },
            { id: 'rates', label: 'Rates', icon: FaTags },
            { id: 'inventory', label: 'Inventory', icon: FaThLarge },
          ].map((item) => {
            const Icon = item.icon;
            const isActive = activeTab === item.id;
            return (
              <li key={item.id}>
                <button
                  onClick={() => setActiveTab(item.id)}
                  className={`w-full flex items-center gap-3 text-left py-2.5 px-4 rounded-lg hover:bg-gray-700 transition ${
                    isActive ? 'bg-gray-700' : ''
                  }`}
                >
                  <Icon className={isActive ? 'text-teal-300' : 'text-gray-300'} />
                  <span>{item.label}</span>
                </button>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Main Content */}
      <div className="flex-1 p-2 md:p-4 bg-gray-100 overflow-auto"> {/* Adjusted padding */}
        <div className="mb-4 md:mb-8 flex items-center justify-between"> {/* Adjusted margins */}
          <AdminHeader />
        </div>

        {/* Performance Overview and Active Tab */}
        <div className="h-full">
          {activeTab === "dashboard" && <Dashboard />}
          {activeTab === "walkin" && <WalkIn />}
          {activeTab === "bookings" && <Bookings />}
          {activeTab === "rates" && <Rates />}
          {activeTab === "inventory" && <Inventory />}
        </div>
      </div>
    </div>
  );
};

export default Home;